import { Injectable } from '@angular/core';
import { toast } from 'ngx-sonner';

@Injectable({
  providedIn: 'root',
})
export class ToastService {
  /**
   * Show a success toast message
   */
  success(message: string): void {
    toast.success(message);
  }

  /**
   * Show an error toast message
   */
  error(message: string): void {
    toast.error(message);
  }

  /**
   * Show an info toast message
   */
  info(message: string): void {
    toast.info(message);
  }

  /**
   * Show a warning toast message
   */
  warning(message: string): void {
    toast.warning(message);
  }
}
